import { AnimationTimeline } from '@desygner/ui-common-animation-timeline';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ReactAppBuilder from 'src/utils/react-app-builder';

export const appContainer = 'animation-preview-app';

class AnimationApp extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  mountApp ({
    onComplete
  }) {
    this.onComplete = onComplete;

    super.mountApp(this.App);
  }

  closeApp () {
    super.closeApp(this.App);
  }

  getProps () {
    const metadata = INKIVE.AnimationFactory.getAnimationConfiguration();
    const pagesOrder = useSelector((state) => state.editor.pagesOrder);
    const pages = useSelector((state) => state.page);
    const mappedPages = useMemo(
      () =>
        pagesOrder.map((pageId) => ({
          id: pages[pageId].id,
          content: pages[pageId].content
        })),
      [pagesOrder, pages]
    );

    return {
      pages: mappedPages,
      metadata,
      size: {
        width: '100%',
        height: '100%'
      },
      options: {
        yoyo: true
      },
      onComplete: this.onComplete
    };
  }

  App = () => {
    const props = this.getProps();
    return <AnimationTimeline {...props} />;
  };
}

export default new AnimationApp({
  appId: appContainer,
  targetNodeSelector: '#animation-preview-container .animation-modal-content-inner-video-wrapper'
});
